/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Type_TranscriptionInputs */

const en_edit_event_group_type_transcription = /** @type {(inputs: Edit_Event_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription`)
};

const fr_edit_event_group_type_transcription = /** @type {(inputs: Edit_Event_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription`)
};

const de_edit_event_group_type_transcription = /** @type {(inputs: Edit_Event_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkription`)
};

const it_edit_event_group_type_transcription = /** @type {(inputs: Edit_Event_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione`)
};

const ru_edit_event_group_type_transcription = /** @type {(inputs: Edit_Event_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транскрипция`)
};

const es_edit_event_group_type_transcription = /** @type {(inputs: Edit_Event_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción`)
};

const zh_cn2_edit_event_group_type_transcription = /** @type {(inputs: Edit_Event_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转录`)
};

const ja_edit_event_group_type_transcription = /** @type {(inputs: Edit_Event_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`転写`)
};

const hi_edit_event_group_type_transcription = /** @type {(inputs: Edit_Event_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलिपि`)
};

const pt_pt2_edit_event_group_type_transcription = /** @type {(inputs: Edit_Event_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrição`)
};

/**
* | output |
* | --- |
* | "Transcription" |
*
* @param {Edit_Event_Group_Type_TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_type_transcription = /** @type {((inputs?: Edit_Event_Group_Type_TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Type_TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_type_transcription(inputs)
	if (locale === "de") return de_edit_event_group_type_transcription(inputs)
	if (locale === "it") return it_edit_event_group_type_transcription(inputs)
	if (locale === "ru") return ru_edit_event_group_type_transcription(inputs)
	if (locale === "es") return es_edit_event_group_type_transcription(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_type_transcription(inputs)
	if (locale === "ja") return ja_edit_event_group_type_transcription(inputs)
	if (locale === "hi") return hi_edit_event_group_type_transcription(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_type_transcription(inputs)
	return en_edit_event_group_type_transcription(inputs)
});